import { defineStore } from 'pinia';
import axios from 'axios';
import Const from '@/const';
const xsrfToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1];
axios.defaults.baseURL = Const.URL;
const isLocalhost = window.location.hostname === 'localhost';
let ApiUrl = `http://localhost:8080/api/`;
if (!isLocalhost) {
    ApiUrl = Const.URL;
}
export const useCasinoStore = defineStore('casino', {
    state: () => ({
        games: [],
        gameCategories: [],
        casinoSideBarCategories: [],
        page: 0,
        gameCache: {},
    }),
    actions: {
        async fetchGames(page = 0, id = 'all') {
            if (this.games.length === 0 && this.gameCache[id]) {
                this.games = Object.values(this.gameCache[id]).flat();
            }
            //   console.log("🚀 ~ fetchGames ~ this.gameCache[id]?.[page]:", this.gameCache[id]?.[page])
            //   if (this.gameCache[id]?.[page]) {
            //     this.games = [...this.games,]
            //     return
            //   }
            try {
                let response;
                if (isLocalhost) {
                    let testConstUrl = `get_casino_game.json`;
                    if (page === 1)
                        testConstUrl = `get_casino_game1.json`;
                    else if (page === 2)
                        testConstUrl = `get_casino_game2.json`;
                    const apiPath = `${ApiUrl}/${testConstUrl}`;
                    response = await axios.get(apiPath, {
                        headers: { Accept: 'application/json' },
                        timeout: 10000,
                        withCredentials: true,
                    });
                }
                else {
                    response = await axios.post(`${Const.URL}/get_casino_game`, {
                        id,
                        page,
                    }, {
                        headers: { Accept: 'application/json' },
                        timeout: 10000,
                        withCredentials: true,
                    });
                }
                if (!this.gameCache[id]) {
                    this.gameCache[id] = {};
                }
                // Store new data in cache only if the page is not already stored
                if (!this.gameCache[id][page]) {
                    this.gameCache[id][page] = response.data;
                }
                // Merge new games, ensuring no duplicate entries
                const newGames = response.data.filter(game => !this.games.some(existingGame => existingGame.id === game.id));
                this.games = [...this.games, ...newGames];
            }
            catch (error) {
                console.error('Error fetching games:', error.message);
            }
        },
        async fetchSideBarCategories() {
            try {
                if (isLocalhost) {
                    const testConstUrl = `http://localhost:8080/api`;
                    const response = await axios.get(`${testConstUrl}/casinoSideBarCategories.json`, {
                        headers: {
                            Accept: 'application/json, text/plain, */*',
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrfToken,
                        },
                        timeout: 10000,
                        withCredentials: true,
                    });
                    this.casinoSideBarCategories = response.data;
                }
                else {
                    const response = await axios.get(`${Const.URL}/apidata/casinoSideBarCategories.json`, {
                        headers: {
                            Accept: 'application/json, text/plain, */*',
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrfToken,
                        },
                        timeout: 10000,
                        withCredentials: true,
                    });
                    this.casinoSideBarCategories = response.data;
                }
            }
            catch (error) {
                console.error('Error fetching side Bar categories:', error.message);
            }
        },
        async fetchGameCategories() {
            try {
                if (isLocalhost) {
                    const testConstUrl = `http://localhost:8080/api`;
                    const response = await axios.get(`${testConstUrl}/get_provider.json`, {
                        headers: {
                            Accept: 'application/json, text/plain, */*',
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrfToken,
                        },
                        timeout: 10000,
                        withCredentials: true,
                    });
                    this.gameCategories = response.data;
                }
                else {
                    const response = await axios.post(`${Const.URL}/get_provider`, {
                        headers: {
                            Accept: 'application/json, text/plain, */*',
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrfToken,
                        },
                        timeout: 10000,
                        withCredentials: true,
                    });
                    this.gameCategories = response.data;
                }
            }
            catch (error) {
                console.error('Error fetching game categories:', error.message);
            }
        },
        incrementPage() {
            this.page++;
        },
        clearGames() {
            this.games = [];
            this.page = 0;
        },
    },
});
